module.exports = __webpack_public_path__ + "img/xiangmuguanli.96472422.png";